import React, { useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
// @ts-ignore
import Form from 'react-validation/build/form';
// @ts-ignore
import Button from 'react-validation/build/button';

import { ValidationInput } from '../../common/ValidationInput';
import { required, email as emailValidator } from '../../common/ValidationRules';
import { ErrorMessage } from '../../common';
import { resetPassword } from '../../../actions/ClientData';
import { toggleModal } from '../../../actions/ViewController';
import { modalTypes } from '../../../consts';

export function ResetPassword() {
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState();

    const emailInputRef = useRef<HTMLInputElement>(null);

    const setErrorInfo = useCallback((response: any, error: any) => {
        if (!response || error) {
            const message = error.data.content?.email;
            setErrorMessage(message);
        }
    }, []);

    const handleContinue = (e: React.ChangeEvent<HTMLInputElement>): void => {
        e.preventDefault();

        setErrorMessage(null);
        dispatch(resetPassword({ email }, setErrorInfo));
    };

    const handleGoBackToLogin = () => {
        dispatch(toggleModal('authModal', modalTypes.LOGIN));
    };

    return (
        <Modal
            className="forgot-password-modal auth-form"
            contentLabel="Reset Password Modal"
            isOpen={true}
        >
            <p className="modal-title">Reset password</p>
            <div className="modal-content">
                <Form>
                    <ValidationInput
                        type="email"
                        name="email"
                        value={email}
                        className="email input--round"
                        placeholder="Email address"
                        ref={emailInputRef}
                        containerClassName="email-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setEmail(e.target.value)}
                        validations={[required, emailValidator]}
                    />
                    <div className="hidden-xs">
                        <Button
                            className="continue btn--round-big"
                            onClick={handleContinue}
                        >
                            RESET PASSWORD
                        </Button>
                        <button
                            className="back margin"
                            onClick={handleGoBackToLogin}
                            type="button"
                        >
                            GO BACK
                        </button>
                    </div>
                    <div className="visible-xs">
                        <Button className="continue" onClick={handleContinue}>
                            SEND
                        </Button>
                    </div>
                </Form>
            </div>
            {errorMessage && <ErrorMessage message={errorMessage} />}
        </Modal>
    );
}
